export default "https://cdn-web.disco.co/email-badge-783e3c08ef63d7d59b9771bd174b410b.png";